import './expo_page.css';
import React from 'react';

function Privacy() {
  return (
    <div>
      <div className="home-title">
        <h1>Privacy Policy sHnapp</h1>
      </div>
      <br />
      <div className="geo-container">
        <div className="tools">
          <section className="py-12 text-left">
            <div className="container mx-auto">
              <p>
                <strong>Ultimo aggiornamento:</strong> 19/08/2025
              </p>

              <p>
                Questa informativa descrive come <strong>Umberto grechi</strong>  raccoglie, utilizza e protegge i dati degli utenti che utilizzano l’app <strong>sHnapp</strong>.
              </p>

              <h2 className="text-im mt-6">1. Informazioni raccolte</h2>
              <ul className="text-gray-600 mt-2 list-disc list-inside">
                <li>Credenziali di accesso (nome utente e password) fornite dall’amministratore per permettere l’autenticazione.</li>
                <li>Dati di localizzazione relativi alle prove geognostiche effettuate.</li>
                <li>Foto scattate e salvate all’interno dell’app, associate alle prove.</li>
              </ul>

              <h2 className="text-im mt-6">2. Finalità del trattamento</h2>
              <p className="text-gray-600">
                I dati raccolti vengono utilizzati esclusivamente per:
              </p>
              <ul className="text-gray-600 mt-2 list-disc list-inside">
                <li>Consentire l’accesso sicuro all’app.</li>
                <li>Registrare e archiviare le posizioni delle prove geognostiche.</li>
                <li>Associare immagini alle attività svolte.</li>
              </ul>
              <p className="text-gray-600 mt-2">Non utilizziamo i dati per finalità di marketing o profilazione.</p>

              <h2 className="text-im mt-6">3. Modalità di conservazione</h2>
              <p className="text-gray-600">
                I dati vengono salvati su server e sono accessibili solo agli utenti autorizzati. Adottiamo misure di sicurezza tecniche e organizzative per proteggere i dati da accessi non autorizzati.
              </p>

              <h2 className="text-im mt-6">4. Condivisione dei dati</h2>
              <p className="text-gray-600">
                Non vendiamo né condividiamo i dati degli utenti con terze parti, salvo che sia necessario per:
              </p>
              <ul className="text-gray-600 mt-2 list-disc list-inside">
                <li>Obblighi di legge.</li>
                <li>Fornitori di servizi strettamente connessi al funzionamento dell’app (es. hosting, database).</li>
              </ul>

              <h2 className="text-im mt-6">5. Diritti degli utenti</h2>
              <p className="text-gray-600">
                Gli utenti possono in qualsiasi momento:
              </p>
              <ul className="text-gray-600 mt-2 list-disc list-inside">
                <li>Richiedere l’accesso ai propri dati.</li>
                <li>Chiedere la rettifica o la cancellazione dei dati.</li>
                <li>Limitare o opporsi al trattamento, nei limiti consentiti dalla legge.</li>
              </ul>
              <p className="text-gray-600 mt-2">
                Per esercitare questi diritti, contattaci all’indirizzo email: <a href="mailto:umberto.grechi@sofhare.com">umberto.grechi@sofhare.com</a>.
              </p>

              <h2 className="text-im mt-6">6. Bambini</h2>
              <p className="text-gray-600">
                L’app non è destinata a minori di 18 anni e non raccoglie consapevolmente dati personali di bambini.
              </p>

              <h2 className="text-im mt-6">7. Modifiche</h2>
              <p className="text-gray-600">
                Ci riserviamo il diritto di aggiornare questa Privacy Policy. Le modifiche verranno pubblicate in questa pagina con data di aggiornamento.
              </p>

              <h2 className="text-im mt-6">8. Contatti</h2>
              <p className="text-gray-600">
                Per qualsiasi domanda sulla privacy, contattaci a: <br />
                📧 <a href="mailto:umberto.grechi@sofhare.com">umberto.grechi@sofhare.com</a> <br />
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Privacy;





